// project import
import dashboard from './dashboard';

// ==============================|| MENU ITEMS ||============================== //

// `dashboard` is now an ARRAY of root-level groups (see menu-items/dashboard.jsx —
// was a single object before, wrapped in [dashboard] here; that silently
// dropped every group after the first for any login whose /api/menu
// response has more than one root group, e.g. distributor users getting
// back group-main + group-distributor). Spread it directly instead of
// re-wrapping it in another array.
const menuItems = {
  items: dashboard
};

export default menuItems;